/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */

import axios from "axios";
import { useContext, useEffect, useState, useCallback, useRef } from "react";
import { MyContext } from "../Context/MyProvider";
import { showTost } from "../showTost";

const Paypal = ({ Amount, ItemType, ItemId }) => {
  const { basUrl, setPayClose, setPlanId, setTransactionId, page, setBuyCoin } =
    useContext(MyContext);

  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [clientId, setClientId] = useState("");
  const [localOrder, setLocalOrder] = useState(null);
  const buttonRenderedRef = useRef(false);

  const updatePaymentState = useCallback((status, transactionId) => {
    if (page === "Upgrade") {
      setPlanId(status);
      if (transactionId) setTransactionId(transactionId);
    } else if (page === "Wallet") {
      setPayClose(status);
    } else {
      setBuyCoin(status);
    }
  }, [page, setBuyCoin, setPayClose, setPlanId, setTransactionId]);

  const createBackendOrder = useCallback(async () => {
    const localData = localStorage.getItem("Register_User");
    if (!localData) {
      throw new Error("Login required for payment.");
    }

    const userData = JSON.parse(localData);
    const itemType = ItemType || (page === "Upgrade" ? "plan" : page === "Wallet" ? "wallet" : "package");
    const itemId = ItemId || 0;

    const orderRes = await axios.post(`${basUrl}create_payment_order`, {
      uid: userData.id,
      item_type: itemType,
      item_id: itemId,
      amount: Amount,
      payment_gateway: "Paypal",
    });

    if (orderRes.data.Result !== "true") {
      throw new Error(orderRes.data.ResponseMsg || "Unable to create PayPal order.");
    }

    if (!orderRes.data.checkout || !orderRes.data.checkout.gateway_order_id || !orderRes.data.checkout.client_id) {
      throw new Error("PayPal checkout data missing from backend.");
    }

    setClientId(orderRes.data.checkout.client_id);
    setLocalOrder(orderRes.data);
    return orderRes.data;
  }, [Amount, ItemId, ItemType, basUrl, page]);

  useEffect(() => {
    if (!Amount || clientId || isScriptLoaded) return;

    createBackendOrder()
      .then((order) => {
      const script = document.createElement("script");
        script.src = `https://www.paypal.com/sdk/js?client-id=${order.checkout.client_id}&currency=${order.checkout.currency}`;
      script.async = true;
      script.onload = () => setIsScriptLoaded(true);
        script.onerror = () => {
          showTost({ title: "Unable to load PayPal checkout." });
          updatePaymentState("PaymentNotDone");
        };
      document.body.appendChild(script);
      })
      .catch((err) => {
        showTost({ title: err.message || "Unable to create PayPal order." });
        updatePaymentState("PaymentNotDone");
      });
  }, [Amount, clientId, createBackendOrder, isScriptLoaded, updatePaymentState]);

  const renderPayPalButton = useCallback(() => {
    if (buttonRenderedRef.current) return;
    buttonRenderedRef.current = true;

    window.paypal
      .Buttons({
        createOrder: () => {
          return localOrder.checkout.gateway_order_id;
        },
        onApprove: async (data) => {
          try {
            const verifyRes = await axios.post(`${basUrl}verify_payment`, {
              order_id: localOrder.order_id,
              paypal_order_id: data.orderID,
              gateway_order_id: data.orderID,
            });

            if (verifyRes.data.Result === "true" && verifyRes.data.status === "granted") {
              updatePaymentState("PaymentVerified", data.orderID);
            } else {
              throw new Error(verifyRes.data.ResponseMsg || "PayPal payment verification failed.");
            }
          } catch (err) {
            showTost({ title: err.message || "PayPal payment verification failed." });
            updatePaymentState("PaymentNotDone");
          }
        },
        onCancel: () => {
          updatePaymentState("PaymentNotDone");
        },
        onError: (err) => {
          console.error(err);
          showTost({ title: "PayPal payment failed." });
          updatePaymentState("PaymentNotDone");
        },
      })
      .render("#paypal-button-container");
  }, [basUrl, localOrder, updatePaymentState]);

  useEffect(() => {
    if (isScriptLoaded && window.paypal && localOrder) {
      renderPayPalButton();
    }
  }, [isScriptLoaded, localOrder, renderPayPalButton]);

  return (
    <div className="w-full">
      <div id="paypal-button-container"></div>
    </div>
  );
};

export default Paypal;
/* jshint ignore:end */
